import { BankReaderName } from "../components/modules/income/BankReader/components/BankReaderFactory/types/BankReaderName";

/* eslint-disable */
export const ENV_COOKIE_LOGIN_NAME =
  window.RUNTIME_COOKIE_NAME || COOKIE_LOGIN_NAME;

export const ENV_API_URL = window.RUNTIME_API_URL || API_URL;
export const ENV_APP_URL = window.RUNTIME_APP_URL || APP_URL;

export const ENV_ELECTRONIC_ID_URL =
  window.RUNTIME_ELECTRONIC_ID_URL || ELECTRONIC_ID_URL;

export const ENV_API_VERSION = window.RUNTIME_API_VERSION || "";
export const ENV_GTM_CONTAINER_ID = window.RUNTIME_GTM_CONTAINER_ID;
export const ENV_IS_PROD = window.RUNTIME_IS_PROD || "false";

export const ENV_DEFAULT_BANK_READER = BankReaderName.TINK;

export const ENV_FLYWIRE_ENVIRONMENT =
  window.RUNTIME_FLYWIRE_ENVIRONMENT || FLYWIRE_ENVIRONMENT;

export const ENV_ENV = window.RUNTIME_ENV || ENV;

export const ENV_MAPS_API_KEY = window.RUNTIME_MAPS_API_KEY || MAPS_API_KEY;

export const ENV_POSTHOG_KEY = window.RUNTIME_POSTHOG_KEY || null;
export const ENV_POSTHOG_HOST = window.RUNTIME_POSTHOG_HOST || null;
